export const actions = {
  UPDATE_USER_NAME: 'UPDATE_USER_NAME',
  UPDATE_PROFILE_PICTURE: 'UPDATE_PROFILE_PICTURE',
  REMOVE_PROFILE_PICTURE: 'REMOVE_PROFILE_PICTURE',
  GET_NOTIFICATION_PREFERENCE: 'GET_NOTIFICATION_PREFERENCE',
  UPDATE_NOTIFICATION_PREFERENCE: 'UPDATE_NOTIFICATION_PREFERENCE',
  TOGGLE_NOTIFICATION_PREFERENCE: 'TOGGLE_NOTIFICATION_PREFERENCE',
  GET_INTEGRATIONS_ACTION: 'GET_INTEGRATIONS_ACTION',
  UPDATE_INTEGRATIONS_ACTION: 'UPDATE_INTEGRATIONS_ACTION',
  UPDATE_CHANNEL_DND_SETTING: 'UPDATE_CHANNEL_DND_SETTING',
  FETCH_USER_PAST_REVIEWS: 'FETCH_USER_PAST_REVIEWS',
  FETCH_USER_IMPORTED_REVIEWS: 'FETCH_USER_IMPORTED_REVIEWS',
  SAVE_USER_PAST_REVIEWS: 'SAVE_USER_PAST_REVIEWS',
  SAVE_USER_IMPORTED_REVIEWS: 'SAVE_USER_IMPORTED_REVIEWS',
  CLEAR_USER_PAST_REVIEWS: 'CLEAR_USER_PAST_REVIEWS',
  FETCH_REVIEW_MODULE_ORG_SETTINGS: 'FETCH_REVIEW_MODULE_ORG_SETTINGS',
  SAVE_REVIEW_MODULE_ORG_SETTINGS: 'SAVE_REVIEW_MODULE_ORG_SETTINGS',
  FETCH_CURRENT_USER_HRBP_DETAILS: 'FETCH_CURRENT_USER_HRBP_DETAILS',
  SET_CURRENT_USER_HRBP_DETAILS: 'SET_CURRENT_USER_HRBP_DETAILS',
  FETCH_CURRENT_USER_REPORTEES_BY_PERSONA:
    'FETCH_CURRENT_USER_REPORTEES_BY_PERSONA',
  SET_CURRENT_USER_REPORTEES_BY_PERSONA: 'SET_CURRENT_USER_REPORTEES_BY_PERSONA'
};

export const updateUserName = (name, id) => ({
  type: actions.UPDATE_USER_NAME,
  name,
  id
});

export const updateProfilePicture = imagePath => ({
  type: actions.UPDATE_PROFILE_PICTURE,
  imagePath
});

export const removeProfilePicture = () => ({
  type: actions.REMOVE_PROFILE_PICTURE
});

export const getNotificationPreferenceDetail = () => ({
  type: actions.GET_NOTIFICATION_PREFERENCE
});

export const updateNotificationPreferenceDetail = (
  requestBody,
  notificationPreferences
) => ({
  type: actions.UPDATE_NOTIFICATION_PREFERENCE,
  requestBody,
  notificationPreferences
});

export const toggleNotificationPreferenceDetail = (
  requestBody,
  notificationPreferences
) => ({
  type: actions.TOGGLE_NOTIFICATION_PREFERENCE,
  requestBody,
  notificationPreferences
});

export const updateChannelDndSettings = (
  requestBody,
  notificationPreferences
) => ({
  type: actions.UPDATE_CHANNEL_DND_SETTING,
  requestBody,
  notificationPreferences
});

export const getIntegrations = () => ({
  type: actions.GET_INTEGRATIONS_ACTION
});

export const updateIntegrations = bodyResponse => ({
  type: actions.UPDATE_INTEGRATIONS_ACTION,
  bodyResponse
});

export const fetchUserPastReviews = userId => ({
  type: actions.FETCH_USER_PAST_REVIEWS,
  userId
});

export const fetchReviewModuleSettings = userId => ({
  type: actions.FETCH_REVIEW_MODULE_ORG_SETTINGS,
  userId
});

export const fetchUserImportedReviews = userId => ({
  type: actions.FETCH_USER_IMPORTED_REVIEWS,
  userId
});

export const saveUserPastReviews = reviews => ({
  type: actions.SAVE_USER_PAST_REVIEWS,
  reviews
});

export const saveUserImportedReviews = reviews => ({
  type: actions.SAVE_USER_IMPORTED_REVIEWS,
  reviews
});

export const clearUserPastReviews = () => ({
  type: actions.CLEAR_USER_PAST_REVIEWS
});

export const saveReviewModuleSettings = reviewOrgSettings => ({
  type: actions.SAVE_REVIEW_MODULE_ORG_SETTINGS,
  reviewOrgSettings
});

export const fetchCurrentUserHrbpDetails = userReferenceId => ({
  type: actions.FETCH_CURRENT_USER_HRBP_DETAILS,
  userReferenceId
});

export const setCurrentUserHrbpDetails = data => ({
  type: actions.SET_CURRENT_USER_HRBP_DETAILS,
  data
});
